import { store } from 'src/stores';
import { logout } from '../services';

export const onLogout = () => {
  store.dispatch(logout());
};
